export default "__VITE_ASSET__B1vHaA3p__"